import React from 'react';

import { EmojiPicker, type EmojiPickerProps } from '@pkg/components';

import './_IconPicker.scss';

interface IconPickerProps {
    onSelect: EmojiPickerProps['onSelectEmoji'];
}

export default function IconPicker({ onSelect }: IconPickerProps) {
    return (
        <div className="IconPicker" id="IconPicker">
            <EmojiPicker onSelectEmoji={onSelect} />
        </div>
    );
}
